import { render } from "./TicketsTable.vue?vue&type=template&id=3d0e5b7c"
import script from "./TicketsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reporting/TicketsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d0e5b7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d0e5b7c', __exports__)) {
    api.reload('3d0e5b7c', __exports__)
  }
  
  module.hot.accept("./TicketsTable.vue?vue&type=template&id=3d0e5b7c", () => {
    api.rerender('3d0e5b7c', render)
  })

}


export default __exports__